import PropTypes from 'prop-types';

import { Autocomplete, InputAdornment, TextField } from '@mui/material';

function Filter({ value, items, onChange, disabled, label, disabledFilter, Icon, testId }) {
  return (
    <Autocomplete
      style={{ width: '12.5rem' }}
      id={label}
      size='small'
      options={items || []}
      getOptionLabel={item => (item.name ? item.name : '')}
      getOptionSelected={(option, value) => option?.name === value?.name}
      onChange={onChange}
      value={value || ''}
      disabled={disabled || disabledFilter}
      data-testid={testId ? testId : ''}
      renderInput={params =>
        Icon ? (
          <TextField
            {...params}
            placeholder={label}
            variant='outlined'
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <Icon />
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <TextField {...params} placeholder={label} variant='outlined' />
        )
      }
    />
  );
}

Filter.defaultProps = {
  items: [],
  value: {},
  onchange: () => {},
  disabled: false,
  label: '',
  disabledFilter: false,
};
Filter.propTypes = {
  items: PropTypes.array,
  value: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  disabledFilter: PropTypes.bool,
};

export default Filter;
